import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const List = ({ item, selectedQuestion, setSelectedQuestion }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.8 });

  const variants = {
    visible: { y: '0px', opacity: 1, transition: { type: 'spring', duration: 4 } },
    hidden: { y: '40px', opacity: 0 }
  };

  return (
    <motion.div
      ref={ref}
      variants={variants}
      animate={inView ? 'visible' : 'hidden'}
      initial="hidden"
      className={`relative
                max-w-[768px] mx-auto border border-[#E8E8E8] rounded-[16px] p-[20px] sm:p-[32px] mb-[16px]
                flex ${selectedQuestion === item.id ? 'bg-purple_transparent' : ''}
            `}>
      <button
        type="button"
        onClick={() => setSelectedQuestion(selectedQuestion === item.id ? '' : item.id)}
        className="absolute inset-0 h-full w-full"></button>
      <div className="mr-[26px] cursor-pointer hide_tap h-[24px] w-[24px]">
        {selectedQuestion === item.id ? (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
              stroke="#98A2B3"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
              stroke="#98A2B3"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      <div>
        <p
          className={`
                    text-18 text-dark_blue font-dmsans_b leading-[28px] ${
                      selectedQuestion === item.id ? 'mb-[8px]' : ''
                    }
                `}>
          {item.question}
        </p>
        <AnimatePresence>
          {selectedQuestion === item.id && (
            <>
              {item?.answer && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{
                    opacity: 1,
                    height: 'auto',
                    transition: { type: 'spring', duration: 0.5 }
                  }}
                  exit={{ opacity: 0, height: 0 }}
                  className="text-16 text-grey font-dmsans_r leading-[24px]">
                  {item.answer}
                </motion.div>
              )}
              {item?.steps && (
                <motion.ul
                  initial={{ opacity: 0, height: 0 }}
                  animate={{
                    opacity: 1,
                    height: 'auto',
                    transition: { type: 'spring', duration: 0.5 }
                  }}
                  exit={{ opacity: 0, height: 0 }}
                  className="text-16 text-grey font-dmsans_r leading-[24px] list-disc">
                  {item?.steps?.map((step, i) => (
                    <li key={i}>{step}</li>
                  ))}
                </motion.ul>
              )}
            </>
          )}
        </AnimatePresence>
      </div>
    </motion.div>
  );
};

export default List;
